import { Card, Badge } from 'react-bootstrap';
import { GeoAlt, Clock, Activity } from 'react-bootstrap-icons';

function timeAgo(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const seconds = Math.floor((now - date) / 1000);

  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'week', seconds: 604800 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 }
  ];

  for (const interval of intervals) {
    const count = Math.floor(seconds / interval.seconds);
    if (count >= 1) {
      return `${count} ${interval.label}${count > 1 ? 's' : ''} ago`;
    }
  }
  return 'Just now';
}

function getSeverityColor(severity) {
  if (severity >= 7) return 'danger';
  if (severity >= 4) return 'warning';
  return 'success';
}

export function LeadCard({ lead, onClick }) {
  const maxSeverity = Math.max(...lead.injuries.map(i => i.severity));

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(lead);
    }
  };

  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      <Card className="lead-card h-100 hover-lift">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div className="d-flex gap-2 align-items-center">
              <Badge bg={getSeverityColor(maxSeverity)} className="lead-severity-badge">
                Severity {maxSeverity}/10
              </Badge>
              {lead.status === 'Sold' && <Badge bg="secondary">Sold</Badge>}
              {lead.status === 'Closed' && <Badge bg="dark">Closed</Badge>}
            </div>
            <span className="lead-time text-muted">
              <Clock size={12} className="me-1" />
              {timeAgo(lead.postedAt)}
            </span>
          </div>

          <h5 className="lead-card-title mb-2">
            {lead.accidentType}
          </h5>

          <div className="lead-card-body-parts mb-3">
            {lead.injuries.map((injury, idx) => (
              <Badge key={idx} bg="light" text="dark" className="me-1 mb-1">
                {injury.bodyPart}
              </Badge>
            ))}
          </div>

          <div className="lead-card-details">
            <div className="d-flex align-items-center mb-2 text-muted">
              <GeoAlt size={14} className="me-2" />
              <span>{lead.location.city}, {lead.location.state}</span>
            </div>
            <div className="d-flex align-items-center text-muted">
              <Activity size={14} className="me-2" />
              <span>Price: </span>
              <span className="ms-1 fw-bold text-success">
                {currencyFormatter.format(lead.estimatedValue)}
              </span>
            </div>
          </div>
        </Card.Body>

        <Card.Footer className="bg-transparent border-top-0">
          <div className="lead-card-contact-blur">
            <span className="blur-text">Contact info hidden</span>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
}
